export default {
  RESET: '重置',
  CONFIRM: '确认',
  CLOSE: '关闭',
  CANCEL: '取消',
  NEXT: '下一步',
  BACK: '返回',
  VERIFY: '确认',
  EDIT: '编辑',
  SAVE: '保存',
  MANAGE: '管理',
  QUIT: '退出',
  KNOW: '我知道了',
  MORE: '更多',
  DELETE: '删除',
  GO_TO_CHECKOUT: '去结算',
  DETERMINE: '确定',
  PUBLISH: '发布',
  VIEW_DETAIL: '查看详情'
};
